import React from "react";
import {
    Navigate,
} from "react-router-dom";

const UserListComponent = React.lazy(() => import("../../../../../components/stk-users/components/list/page"));
const UserAddComponent = React.lazy(() => import("../../../../../components/stk-users/components/add/page"));

export const userRoute = [
    {
        path: 'list',
        element: <UserListComponent />
    },
    {
        path: 'add',
        element: <UserAddComponent />
    },
    {
        path: 'edit',
        element: <Navigate to="/configuration/users/add" />
    },
    {
        path: 'edit/:id',
        element: <UserAddComponent />
    },
    {
        path: '',
        element: <Navigate replace to="/configuration/users/list" />
    },
];